<template>
  <v-dialog v-model="dialog" max-width="800px" persistent>
    <v-card>
      <v-card-title class="headline">
        {{ $t('esgPlatform.selectSDGGoals') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      
      <v-row   v-if="sdgGoals.length === 0" align="center" justify="center">
          <v-col class="text-center">
            <div>{{ $t('esgPlatform.noSDGGoalsFound') }}</div>
          </v-col>
      </v-row>
      <v-card-text>
        <v-list>
          <v-list-item
            v-for="sdg in sdgGoals" 
            :key="sdg._id" 
            @click="toggleSelection(sdg._id)"
            :class="{ 'selected-sdg': isSelected(sdg._id) }"
            class="sdg-card mb-2"
          >
            <v-list-item-avatar tile size="48" class="mr-4">
              <v-img 
                :src="sdg.icon" 
                contain
              ></v-img>
            </v-list-item-avatar>
            
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ sdg.goalNumber }}. {{ sdg.title }}
              </v-list-item-title>
            </v-list-item-content>
            
            <v-list-item-action>
              <v-checkbox
                :input-value="isSelected(sdg._id)"
                @click.stop="toggleSelection(sdg._id)"
                color="primary"
              ></v-checkbox>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card-text>
      
      <v-divider></v-divider>
      
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="closeDialog">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn color="primary" @click="confirmSelection">
          {{ $t('confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SdgGoalSelector',
  props: {
    dialogI: {
      type: Boolean,
      default: false
    },
    selectedGoals: {
      type: Array,
      default: () => []
    },
    sdgGoals: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localSelectedGoals: []
    };
  },
  computed: {
    dialog: {
      get() {
        return this.dialogI;
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal');
        }
      }
    }
  },
  watch: {
    dialogI(newVal) {
      if (newVal) {
        // Initialize with current selected goals
        this.localSelectedGoals = [...this.selectedGoals];
      }
    }
  },
  methods: {
    isSelected(goalId) {
      return this.localSelectedGoals.includes(goalId);
    },
    toggleSelection(goalId) {
      const index = this.localSelectedGoals.indexOf(goalId);
      if (index > -1) {
        this.localSelectedGoals.splice(index, 1);
      } else {
        this.localSelectedGoals.push(goalId);
      }
    },
    confirmSelection() {
      this.$emit('confirm', this.localSelectedGoals);
      this.closeDialog();
    },
    closeDialog() {
      this.$emit('closeModal');
    }
  }
};
</script>

<style scoped>
.sdg-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 4px;
  border: 2px solid transparent;
}

.sdg-card:hover {
  background-color: #f5f5f5;
}

.selected-sdg {
  border: 2px solid #4CAF50;
  background-color: #f1f8f4;
}
</style>